import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IPushNotificationsPanelButtonProps } from './types';
import { BOARD_SECTION_PUSH_NOTIFICATIONS } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function PushNotificationsPanelButton ({
    indicatorBoolean,
    tooltip,
    onClick
}: IPushNotificationsPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            indicatorBoolean={indicatorBoolean}
            isOpened={subTab === EBoardSetting.APP_NOTIFICATIONS}
            title={BOARD_SECTION_PUSH_NOTIFICATIONS}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.APP_NOTIFICATIONS);
                onClick();
            }}
        />
    );
}
